/**
 * AWS Amplify v6 configuration for Cognito authentication
 *
 * This file must be imported once at app startup (side-effect import).
 * It configures Amplify to use the Cognito User Pool with optional Google OAuth.
 */

import { Amplify } from 'aws-amplify';

const stage = import.meta.env.VITE_ENVIRONMENT as string;
const appDomain =
  stage === 'production'
    ? 'https://internal.winclap.com'
    : `https://${stage}.it.staging.winclap.com`;

const cognitoDomain = import.meta.env.VITE_COGNITO_DOMAIN as string | undefined;

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID as string,
      userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID as string,
      // OAuth is only configured when VITE_COGNITO_DOMAIN is set
      ...(cognitoDomain
        ? {
            loginWith: {
              oauth: {
                domain: cognitoDomain,
                scopes: ['email', 'openid', 'profile'],
                redirectSignIn: ['http://localhost:3000/', `${appDomain}/`],
                redirectSignOut: [
                  'http://localhost:3000/login',
                  `${appDomain}/login`,
                ],
                responseType: 'code' as const,
              },
            },
          }
        : {}),
    },
  },
});
